<template>
  <!-- Menu Item without SubPage -->
  <div v-if="showSubMenu(item) === 0 && item.NameMenu && getYesNo(item, 'ShowHeadMenu')">
    <NuxtLink
      class="text-none text-decoration-none navbaritemstext"
      :to="{ path: $methods.localePath(`${basePath}${item.NameUrl}`) }"
    >
       <v-list-item class="py-0"> 
        <v-row>
          <v-col >
            {{ item.NameMenu }}
          </v-col>
        </v-row>
      </v-list-item>
    </NuxtLink>
  </div>

  <!-- Menu Item with SubPage -->
   <div v-else-if=" showSubMenu(item) > 0 &&  item.NameMenu && getYesNo(item, 'ShowHeadMenu')">
    <v-list-group>
      <template v-slot:activator="{ props }">
        <v-list-item v-bind="props">
          <NuxtLink
            class="text-none text-decoration-none navbaritemstext"
            :to="{ path: $methods.localePath(`${basePath}${item.NameUrl}`) }"
          >
            <v-row>
              <v-col >
                {{ item.NameMenu }}
              </v-col>
            </v-row>
          </NuxtLink>
        </v-list-item>
      </template>

      <!-- Recursive Call for SubPage "-->
      <template v-for="(subItem, index) in item.SubPage" :key="index">
         <MenuItemDrawer v-if="$helpers.isset(pageNames[subItem.Code])" :item="subItem" :base-path="`${props.basePath}${item.NameUrl}/`" /> 
      </template>
    </v-list-group>
  </div> 
</template>

<script setup>
import { useNuxtApp } from '#app';
// Props
const { $helpers,$methods } = useNuxtApp()
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  basePath: {
    type: String,
    required: true,
  },
});
 const dataAll = useDataAll();
 const pageNames = dataAll.getKey("pageNames", []);

function showSubMenu(menuItem){
  if(menuItem.SubPage ){
    return menuItem.SubPage.filter(i =>getYesNo(i, 'ShowHeadMenu')).length;
  } 
  return 0;
}

</script>
